// third-party

// assets
import DashboardIcon from '@mui/icons-material/Dashboard';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import CampaignIcon from '@mui/icons-material/Campaign';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
// import ListIcon from '../assets/discovery/list-icon.svg'

const icons = {
  DashboardIcon: DashboardIcon,
  AnalyticsIcon: AnalyticsIcon,
  CampaignIcon: CampaignIcon,
  LiveTvIcon: LiveTvIcon,
  WorkspacePremiumIcon: WorkspacePremiumIcon,
  FormatListBulletedRoundedIcon: FormatListBulletedRoundedIcon,
  ReceiptLongIcon: ReceiptLongIcon,
  InsightsOutlinedIcon: InsightsOutlinedIcon,
  FactCheckOutlinedIcon: FactCheckOutlinedIcon,
  PlaylistAddCheckOutlinedIcon: PlaylistAddCheckOutlinedIcon,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'dashboard',
  title: '',
  icon: icons.DashboardIcon,
  type: 'group',
  children: [
    {
      id: 'discover',
      title: 'Discover',
      type: 'item',
      url: '/planner/discover',
      icon: icons.DashboardIcon,
      breadcrumbs: false,
    },
    {
      id: 'unique-reach',
      title: 'Unique Reach',
      type: 'item',
      url: '/planner/unique-reach',
      icon: icons.InsightsOutlinedIcon,
      breadcrumbs: false,
    },
    {
      id: 'collab-list',
      title: 'Collab List',
      type: 'item',
      url: '/planner/collab-list',
      icon: icons.FormatListBulletedRoundedIcon,
      breadcrumbs: false,
    },
    {
      id: 'campaigns',
      title: 'Campaign',
      type: 'item',
      url: '/planner/campaign',
      icon: icons.CampaignIcon,
      breadcrumbs: false,
    },
    {
      id: 'video-qc',
      title: 'Video QC',
      type: 'item',
      url: '/planner/video-qc',
      icon: icons.PlaylistAddCheckOutlinedIcon,
      breadcrumbs: false,
    },
    {
      id: 'competitors-analysis',
      title: 'Competitors Analysis',
      type: 'item',
      // url: '/competitor-insights/',
      url :'/planner/competitor-report-dashboard',
      icon: icons.AnalyticsIcon,
      breadcrumbs: false,
      premiumIcon: icons.WorkspacePremiumIcon,
    },
    {
      id: 'curated-list',
      title: 'Curated List',
      type: 'item',
      url: '/planner/curated-list',
      icon: icons.LiveTvIcon,
      breadcrumbs: false,
    },
    {
      id: 'invoices',
      title: 'Invoices',
      type: 'item',
      url: '/planner/invoices',
      icon: icons.ReceiptLongIcon,
      breadcrumbs: false,
      // Filtered out of the sidebar for everyone else; the route and every
      // endpoint behind it enforce the same gate server-side.
      staffOnly: true,
    },
    // My Requests (/planner/feedback) is not listed here on purpose. It is
    // reached from the Feedback button's menu in the header.
    {
      id: 'feedback-board',
      title: 'Feedback Board',
      type: 'item',
      // Outside the planner shell, so this leaves the sidebar behind.
      url: '/feedbackboard',
      icon: icons.FactCheckOutlinedIcon,
      breadcrumbs: false,
      staffOnly: true,
    },
  ],
};

export default dashboard;
